import React, { useState } from "react";
import axios from "../common/axios";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from "../components/ui/card";
import ShadcnPageWrapper from "./ShadcnPageWrapper";

export default function ResetPW() {
  const [email, setEmail] = useState("");
  const [isValid, setIsValid] = useState(false);
  // const history = useHistory();
  const navigate = useNavigate(); // useNavigate 사용

  function isValidEmail(email) {
    const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return re.test(email);
  }

  const handleEmailChange = (e) => {
    const emailValue = e.target.value;
    setEmail(emailValue);
    setIsValid(isValidEmail(emailValue));
  };

  const sendEmail = async (e) => {
    try {
      const response = await axios.post(`/dpresetpw`, { email });
      if (response.data.success) {
        Swal.fire({
          title: "성공!",
          text: "비밀번호 재설정 이메일이 발송되었습니다.",
          icon: "success",
          confirmButtonText: "확인",
        }).then((result) => {
          if (result.isConfirmed) {
            navigate("/dplogin");
          }
        });
      } else {
        Swal.fire({
          title: "오류",
          text: response.data.message,
          icon: "error",
          confirmButtonText: "확인",
        });
      }
    } catch (err) {
      const errorMessage = err.response?.data?.error || "Error during login";
      Swal.fire({
        title: "오류",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "확인",
      });
    }
  };

  return (
    <ShadcnPageWrapper>
      <div className="flex min-h-screen">
        {/* 좌측: 재설정 폼 */}
        <div className="flex flex-1 flex-col items-center justify-center px-4 py-12">
          <div className="w-full sm:w-[350px]">
            <div className="mb-8 flex flex-col items-center gap-2">
              <img src="/images/g1313.png" alt="삼성중공업" className="h-10 w-auto" />
              <h1 className="m-0 text-xl font-bold text-foreground">
                삼성중공업 하이테크 통합 DP 시스템
              </h1>
              <p className="m-0 text-sm text-muted-foreground">
                비밀번호 재설정을 위한 이메일을 입력하세요.
              </p>
            </div>

            <Card>
              <CardHeader>
                <CardTitle className="text-base no-underline">비밀번호 재설정</CardTitle>
                <CardDescription>등록하신 이메일로 재설정 링크를 보내드립니다.</CardDescription>
              </CardHeader>
              <CardContent>
                <div className="space-y-4">
                  <div className="space-y-1.5">
                    <Label htmlFor="email">이메일</Label>
                    <Input
                      id="email"
                      type="text"
                      placeholder="이메일"
                      name="email"
                      autoComplete="off"
                      onChange={handleEmailChange}
                    />
                  </div>

                  <div className="flex gap-2">
                    <Button
                      type="button"
                      disabled={!isValid}
                      onClick={sendEmail}
                      className="flex-1 border-0 bg-[hsl(222,80%,40%)] text-white hover:bg-[hsl(222,80%,40%)]/80"
                    >
                      이메일 보내기
                    </Button>
                    <Button asChild variant="outline" className="flex-1">
                      <RouterLink to={{ pathname: "/dplogin" }} className="no-underline">
                        취소
                      </RouterLink>
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>

        {/* 우측: 브랜드 패널 (lg 이상에서만 표시) */}
        <div className="hidden flex-1 flex-col items-center justify-center bg-[#0F2744] px-12 lg:flex">
          <div className="max-w-md text-center text-white">
            <h2 className="m-0 text-3xl font-bold leading-tight">
              삼성중공업 하이테크 부문 DP 시스템
            </h2>
            <p className="m-0 mt-4 text-base text-white/70">
              Oracle Unifier와 연동되어 승인도·제작도의 계획/실적 데이터를 실시간으로 관리합니다.
            </p>
          </div>
        </div>
      </div>
    </ShadcnPageWrapper>
  );
}
